import React from 'react';
import BottomSheet from '../../bottom-sheet/bottom-sheet';
import BranTokensWalletContent from './bran-tokens-wallet-content';
import { X } from 'lucide-react';

interface BranTokensWalletBottom{
    open: boolean
    setOpen: (open: boolean) => void
}

const BranTokensWalletBottom: React.FC<BranTokensWalletBottom> = ({ open, setOpen }) => {
    return (
        <>

            <div className="col-10">
                <BottomSheet disableDrag snapPoints={[0, 1]} open={open} setOpen={setOpen}>
                        <div id="username-suggestions"></div>
                        <div className="modal-content modal-content-likes">
                            <div className="modal-header modal-header-add-post" style={{ borderBottom: "0!important" }}>
                                <span style={{ cursor: "pointer", right: 10, marginRight: 5, top: 10, position: "absolute" }} onClick={() => setOpen(false) } className="d-flex align-items-center svg-icons-color btn-dark">
                                    <X opacity={.6}/>
                                </span>
                            </div> 
                            
                            <div className="modal-body modal-body-bran-wallet" style={{ position: "static" }}>
                                <BranTokensWalletContent/>
                            </div>
                        </div>
                </BottomSheet>
            </div>
        </>
    );
};

export default BranTokensWalletBottom;